import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormService, useI18n } from "../../../../../contexts";
import { FormServiceFieldGeneralIsEmbeddingOnlyExternalResources } from "../general";
import { FormServiceFieldTechnicalDefinitionsTable } from "./definitions";
import { FormServiceFieldHandlingDeleteTechnicalDefinitionsAfterOptOut, FormServiceLayout } from "../..";
import { FormHeadline } from "../../../headline";
import { Form } from "antd";
const FormServiceFieldTechnicalCompose = ()=>{
    const { __, _i } = useI18n();
    const { essentialGroupId } = useFormService();
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.group !== nextValues.group,
        children: (param)=>{
            let { getFieldValue } = param;
            const isOptOutOptionUsable = getFieldValue("group") !== essentialGroupId;
            return /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(FormHeadline, {
                        offset: FormServiceLayout.labelCol.span,
                        description: _i(__("For each service you use, you should specify all cookies that are used by it. You can find this out in the developer console of your browser. Please note that there are several types of cookies and according to {{aEprivacy}}ePrivacy Directive (Directive 2009/136/EC) Recital 66{{/aEprivacy}} you have to inform your visitors not only about (HTTP) cookies, but also about cookie-like information."), {
                            aEprivacy: /*#__PURE__*/ _jsx("a", {
                                href: __("https://devowl.io/go/eu-directive-2009-136-ec"),
                                target: "_blank",
                                rel: "noreferrer"
                            })
                        }),
                        children: __("Technical cookie information")
                    }),
                    /*#__PURE__*/ _jsx(FormServiceFieldGeneralIsEmbeddingOnlyExternalResources, {}),
                    isOptOutOptionUsable && /*#__PURE__*/ _jsx(FormServiceFieldHandlingDeleteTechnicalDefinitionsAfterOptOut, {}),
                    /*#__PURE__*/ _jsx(FormServiceFieldTechnicalDefinitionsTable, {})
                ]
            });
        }
    });
};
export { FormServiceFieldTechnicalCompose };
